import { render, staticRenderFns } from "./HsabExpenseCardRowPayee.vue?vue&type=template&id=64dabb40&scoped=true"
import script from "./HsabExpenseCardRowPayee.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowPayee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dabb40",
  null
  
)

export default component.exports